'use client';

import { useAuthContext } from '@/contexts/auth';

const MainText = ({ children }: { children: React.ReactNode }) => (
	<div className="text-xl font-bold">{children}</div>
);

const SubText = ({ children }: { children: React.ReactNode }) => (
	<div className="text-sm">{children}</div>
);

const StatItem = ({
	value,
	label,
}: { value: number | string; label: string }) => (
	<div className="flex items-center justify-center gap-x-2">
		<MainText>{value}</MainText>
		<SubText>{label}</SubText>
	</div>
);

export const ProfileAvatar = ({
	url,
	name,
	widthClass = 'w-15',
	heightClass = 'h-15',
}: {
	url: string;
	name: string;
	widthClass?: string;
	heightClass?: string;
}) => (
	<img
		src={url ? url : '/images/user.png'}
		alt={`${name}'s avatar`}
		className={`${widthClass} ${heightClass} rounded-full object-cover`}
	/>
);

const UserInfo = ({ name, email }: { name: string; email: string }) => (
	<div className="flex flex-col items-center">
		<MainText>{name}</MainText>
		<SubText>{email}</SubText>
	</div>
);

export const ProfileStats = () => {
	const { user } = useAuthContext();

	if (!user) return null;

	const { fullName, avatar, email, following, followers, published } = user;

	return (
		<div className="flex flex-col items-center gap-y-5 text-secondary-black">
			<div className="flex flex-col items-center gap-y-2.5">
				<ProfileAvatar url={avatar} name={fullName} />
				<UserInfo name={fullName} email={email} />
			</div>

			<div className="flex flex-col gap-y-2">
				<StatItem value={following} label="Following" />
				<StatItem value={followers} label="Followers" />
				<StatItem value={published} label="Published" />
			</div>
		</div>
	);
};
